export default "__VITE_ASSET__venG7LmR__"